var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import Trend from 'react-trend';
import Theme from 'Theme';
var GraphLine = /** @class */ (function (_super) {
    __extends(GraphLine, _super);
    function GraphLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GraphLine.prototype.render = function () {
        var data = this.props.data;
        var placeholder = Array.from({ length: 20 }, function () {
            return Math.floor(Math.random() * 10);
        });
        return (React.createElement(Trend, { autoDraw: true, data: data || placeholder, stroke: Theme.color.primary, strokeOpacity: data && data.length > 2 ? 1 : 0.1, strokeWidth: 3, padding: Theme.common.size.space, smooth: true, radius: 20 }));
    };
    return GraphLine;
}(Component));
export default GraphLine;



//////////////////
// WEBPACK FOOTER
// ./src/components/GraphLine.tsx
// module id = 1031
// module chunks = 0